import { Component } from 'react';
import { Dialog, DialogTitle, Grid, DialogContent, DialogActions, MenuItem, FormControlLabel,FormGroup, Checkbox } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';  
import CancelIcon from '@mui/icons-material/Cancel';  
import DeleteIcon from "@mui/icons-material/Delete";
import { CustomFilterProps } from './customFilterProps';
import DialogStyles from '../../assets/css/dialog.Styles';
import CustomTextField from '../customTextField/customTextField';
import { GeneralStyles } from '../../assets/css/general.styles';
import CustomButton from '../customButton/customButton';
import CustomSelect from '../customSelect/customSelect';
import CustomDatePicker from '../customDatePicker/customDatePicker';


class CustomFilter extends Component<CustomFilterProps> {
  render() {
    const { open, onClose, onFilter, filters, filterOptions, onFilterChange,handleExport =null, handleReset=null, handleImport = null } = this.props;

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle style={DialogStyles.dialogTitle}>Filter Criteria</DialogTitle>
        <DialogContent>
          {Object.entries(filterOptions).map(([filterName, config]) => {
            const label = config.label || filterName.charAt(0).toUpperCase() + filterName.slice(1);
            if (config.type === 'select' && config.options) {
              return (
                <div style={{ width: '400px' }} key={filterName}>
                  <CustomSelect
                    label={label}
                    name={`${filterName}Id`}
                    multiple={true}
                    value={filters[filterName] as number[] || []}
                    type="text"
                    required={false}
                    onChange={(e) => onFilterChange(filterName, e.target.value)}
                    SelectProps={{
                      children: config.options.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                      )),
                    }}
                  />
                </div>
              );
            } else if (config.type === 'text') {
              return (
                <div style={{ width: '400px' }} key={filterName}>
                  <CustomTextField
                    label={label}
                    type="text"
                    required={false}
                    name={filterName}
                    value={filters[filterName] as string || ''}
                    onChange={(e) => onFilterChange(filterName, e.target.value)}
                  />
                </div>
              );
            } else if (config.type === 'checkbox') {
              return (
                <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "400px" }}> 
                <b style= {{marginTop:'20px'}}>{config.helperMessage}</b>
                  <div style={{ display: "flex", alignItems: "center" }} key={filterName}>
                  <Grid container  sx={{ flexDirection: { xs: "column", sm: "row" } }} >
                    <Grid item xs={12} sm={6} md={6}>
                      <span style={{ minWidth: "200px" }}>{config.label}</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <FormGroup row style={{ display: "flex", alignItems: "center", marginLeft: "16px" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={GeneralStyles.checkBoxStyle}
                                checked={filters[filterName] === true}
                                onChange={() => {
                                  onFilterChange(filterName, filters[filterName] === true ? null : true);
                                }}
                              />
                            }
                            label="Yes"
                            style={{ marginRight: "16px" }}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={GeneralStyles.checkBoxStyle}
                                checked={filters[filterName] === false}
                                onChange={() => {
                                  onFilterChange(filterName, filters[filterName] === false ? null : false);
                                }}
                              />
                            }
                            label="No"
                          />
                        </FormGroup>
                    </Grid>
                    </Grid>
                  </div> 
              </div>
              );
            }
             else if (config.type === 'date') { 
              return (
                <div style={{ width: '400px' }} key={filterName}>
                  <CustomDatePicker
                    value={filters[filterName] as string || ''}
                    label={label}
                    required={false}
                    onChange={(date: any) => onFilterChange(filterName, date)}
                    error={false} 
                    helperText={''} 
                  />
                </div>
              );
            }
          })}
        </DialogContent>
        <DialogActions style={DialogStyles.dialogActions}> 
          <Grid container spacing={2}>
            <Grid item xs={12} style={{marginBottom: '-30px'}}>
              <CustomButton
                onClick={onFilter}
                style={DialogStyles.confirmDialog} 
                startIcon={<CheckCircleIcon />}
              >
                Done
              </CustomButton>
            </Grid> 
            {handleReset && ( 
              <Grid item xs={6}>
                <CustomButton
                  style={DialogStyles.resetDialog}
                  onClick={handleReset} 
                  startIcon={<DeleteIcon />}
                >
                  Reset
                </CustomButton>
              </Grid>
            )}
            <Grid item xs={handleReset ? 6 : 12}>
              <CustomButton
                style={DialogStyles.cancelDialog}
                onClick={onClose} 
                startIcon={<CancelIcon />}
              >
                Cancel
              </CustomButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CustomFilter;
